import React from "react";
import classNames from "classnames";

import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

const MentionList = React.forwardRef<
  { onKeyDown: (props: { event: KeyboardEvent }) => boolean },
  Props
>(({ items, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  React.useEffect(() => {
    setSelectedIndex(0);
  }, [items]);

  const selectItem = (index: number) => {
    const item = items[index];
    if (item) {
      command(item);
    }
  };

  React.useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: { event: KeyboardEvent }) => {
      if (event.key === "ArrowUp") {
        setSelectedIndex((selectedIndex + items.length - 1) % items.length);
        return true;
      }
      if (event.key === "ArrowDown") {
        setSelectedIndex((selectedIndex + 1) % items.length);
        return true;
      }
      if (event.key === "Enter") {
        selectItem(selectedIndex);
        return true;
      }
      return false;
    },
  }));

  if (!items.length) {
    return null;
  }

  return (
    <div className={styles.mentionList}>
      {items.map((item, index) => (
        <div
          key={item.id}
          className={classNames(styles.item, {
            [styles.active]: index === selectedIndex,
          })}
          onClick={() => selectItem(index)}
        >
          <div className={styles.avatar}>
            <ResourceAvatar resource={item.resource} />
          </div>
          <div className={styles.info}>
            <p className={styles.name}>{item.label}</p>
            {!!item.resource.profession && (
              <p className={styles.profession}>{item.resource.profession}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
});

export { MentionList };
